<template>
  <div class="path-activity-item px-3 py-2 border">
    <div class="d-flex justify-content-between align-items-center">
      <div class="d-flex justify-content-start align-items-center">
        <span class="font-weight-bold mr-4">
          活動日時
        </span>
        <span class="path-activity-item__activity-at">
          {{ pathActivity.activityAt | prettyDate }}
        </span>
      </div>
      <router-link
        v-if="canEdit"
        class="text-decoration-none"
        :to="`/members/${userId}/profile/path_activities/${pathActivity.id}`">
        <IconButton
          width="24"
          height="24"
          icon-size="18"
          icon="edit" />
      </router-link>
    </div>
    <!-- eslint-disable -->
    <p
      class="path-activity-item__description mt-2"
      v-html="sanitizedLink(pathActivity.description)" />
    <!-- eslint-enable -->
  </div>
</template>

<script>
import IconButton from '@/components/parts/IconButton.vue'
import sanitizedLinkMixin from '@/components/mixin/sanitizedLink'
export default {
  components: {
    IconButton
  },
  mixins: [sanitizedLinkMixin],
  props: {
    canEdit: {
      type: Boolean,
      required: true,
    },
    pathActivity: {
      type: Object,
      required: true
    }
  },
  computed: {
    userId() {
      return this.pathActivity.user.id
    }
  }
}
</script>

<style lang="scss" scoped>
.path-activity-item {
  border: 1px solid $grey10;
  border-radius: 6px;
  font-size: $fs-m;

  &__description {
    white-space:pre-wrap;
    word-wrap:break-word;
  }

  &__activity-at {
    font-size: $fs-s;
  }
}
</style>